/* RESPONSIBLE TEAM: team-inbox-management */
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

export default class MultilingualController extends Controller {
  queryParams = ['tab'];

  @tracked tab = 'general';

  get selectedTab() {
    return this.tab;
  }

  @action
  changeTab(tab: string) {
    this.set('tab', tab);
    this.tab = tab;
  }
}
